import { collections } from "@/mocks/home";

export default function CollectionIndex() {
  return (
    <section
      id="collections"
      className="w-full border-y border-background-200/70 bg-background-100 py-12 md:py-16"
    >
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-list-ordered"></i>
              </span>
              COLLECTION INDEX
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              黑料合集索引
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              按编号排好的黑料大合集与黑料汇总，点进去就是完整整理。
            </p>
          </div>
          <div className="flex items-center gap-3">
            <span className="whitespace-nowrap rounded-full bg-background-50 px-3.5 py-1.5 text-xs font-medium text-foreground-700 ring-1 ring-background-200">
              共 36 个在更合集
            </span>
            <a
              href="#feed"
              className="cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-4 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              查看整理流
            </a>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {collections.map((item) => (
            <a
              key={item.id}
              href="#feed"
              className="group flex cursor-pointer flex-col rounded-lg border border-background-200/80 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-start justify-between">
                <span className="font-heading text-3xl font-bold leading-none text-background-400 transition-colors group-hover:text-primary-500">
                  {item.no}
                </span>
                <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-800">
                  {item.category}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold leading-snug text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                {item.desc}
              </p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3 text-[11px] text-foreground-500">
                <span className="flex items-center gap-1">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-file-list-3-line"></i>
                  </span>
                  {item.count} 条
                </span>
                <span>{item.updated} 更新</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}